<template>
  <ul class="my-0 list-unstyled">
    <matches v-if="!isEmpty(matches)"
      :matches="matches"
      view="popover"
    />

    <li v-if="description" class="row-content row-content_text">
      <span
        class="row-content--main"
        v-html="description"
        v-line-clamp="4"
      />
    </li>

    <partial-owners v-if="!isEmpty(researchers)"
      :lineClamp="3"
      :owners="researchers"
      :highlights="highlightResearchers"
      :highlightKeys="['participants.participant_name.normalized', 'participants.initial_name.normalized']"
      :renderWithLinkTo="false"
      :isText="true"
      :containerClass="`mt-2 row-content_text`">
    </partial-owners>

    <partial-organisations v-if="!isEmpty(organisations)"
      :lineClamp="3"
      :organisations="organisations"
      :highlights="highlightOrganisations"
      :isWithCount="false"
      :isText="true"
      :containerClass="`mt-2 row-content_text`">
    </partial-organisations>

    <li v-if="!isEmpty(data.start_date)" class="row-content row-content_text mt-2">
      <span class="row-content--main">
        <span class="t-500">Start:</span> {{ data.start_date | formatDate('YYYY-MM-DD') }}
      </span>
    </li>

    <li v-if="!isEmpty(data.end_date)" class="row-content row-content_text">
      <span class="row-content--main">
        <span class="t-500">End:</span> {{ data.end_date | formatDate('YYYY-MM-DD') }}
      </span>
    </li>

    <li v-if="!isEmpty(data.keywords) && keywords" class="row-content row-content_text mt-2">
      <span class="row-content--main">
        <span class="t-500">Keywords:</span>
        <span v-html="keywords" v-line-clamp="4" />
      </span>
    </li>
    <li v-if="data.total_cost && data.total_cost_currency" class="row-content row-content_text mt-2">
      <span class="row-content--main">
        <span class="t-500">Funding amount:</span>
        <span>{{ { amount: data.total_cost, currency: data.total_cost_currency } | formatCurrency }} from {{ data.funding_source.name }}</span>
      </span>
    </li>
  </ul>
</template>

<script>
import processing from '@/mixins/search/results/project'

import PartialOrganisations from '@/components/search/results/partials/Organisations'
import PartialOwners from '@/components/search/results/partials/Owners'
import Matches from '@/components/search/results/partials/Matches'

export default {
  name: 'projectResultPopover',
  mixins: [processing],
  components: {
    PartialOrganisations,
    PartialOwners,
    Matches
  },
  mounted () {
    if (
      !this.isEmpty(this.matches) ||
      this.description ||
      !this.isEmpty(this.researchers) || !this.isEmpty(this.organisations) ||
      this.data.start_date ||
      this.data.end_date ||
      !this.isEmpty(this.data.keywords) ||
      (this.data.total_cost && this.data.total_cost_currency)
    ) {
      this.$emit('setIsEmptyPopover', false)
    } else {
      this.$emit('setIsEmptyPopover', true)
    }
  }
}
</script>
